// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/main.scss
// module id = 24
// module chunks = 2